// TiposTable_v2.jsx
import React from 'react'
import { ReusableTable } from 'components/Tables/ReusableTable'
import TipoRow from './TipoRow'

const HEADERS = ['Nombre', 'Categoría', 'Vinculado']
const COLUMNCLASSES = [
  'ta-left',
  'ta-left',
  'ta-vin',
]

export const TiposTable_v2 = ({ tipos }) => {
  return (
    <ReusableTable dataHeader={HEADERS} headerClassNames={COLUMNCLASSES}>
      
      {tipos.data.map(tipo => (
          <TipoRow key={tipo._id} t={tipo} />
      ))}
 
    </ReusableTable>
  )
}
